import React from "react";

export const MARGINS: any = {
    'h2': {
        top: '48px',
        bottom: '24px',
    },
    'h3': {
        top: '48px',
        bottom: '24px',
    },
    'h4': {
        top: '32px',
        bottom: '16px',
    },
    'p': {
        top: undefined,
        bottom: '24px',
    },
    'div': {
        top: undefined,
        bottom: undefined
    },

}
export const blockQuoteStyle = {
    '&.copy-quote, &.small-text': {
        textAlign: 'center',
        color: 'text.primary',
    },
}

export const ulStyle: React.CSSProperties = {
    listStyle: 'none',
    textAlign: 'start',
    marginTop: 4,
    padding: 0,
}

export const olStyle: React.CSSProperties = {
    listStyle: 'none',
    textAlign: 'start',
    marginTop: 4,
    counterReset: 'item',
    padding: 0,
}

export const ulLiStyle = {
    marginTop: 4,
    marginLeft: 0,
    position: 'relative',
    "&::before": {
        content: '""',
        display: 'inline-block',
        width: '8px',
        height: '8px',
        backgroundColor: 'primary.main',
        marginRight: 3,
        marginBottom: '2px'
    },
}

export const olLiStyle = {
    marginTop: 4,
    '&::before': {
        content: 'counters(item, ".") "."',
        counterIncrement: 'item',
        color: 'primary.main',
        fontWeight: 700,
        fontFamily: 'var(--font-family-bold)',
        marginRight: 2,
    },
}

export const imgOuterBoxStyle = (float?: 'left' | 'right') => ({
    width: { md: float ? '50%' : '100%', xs: '100%' },
    float: { xs: 'none', md: float || 'none' },
    marginBottom: 8,
});

export const imgInnerBoxStyle = (float?: 'left' | 'right') => ({
    marginLeft: { xs: undefined, md: float === 'right' ? 6 : undefined },
    marginRight: { xs: undefined, md: float === 'left' ? 6 : undefined },
    marginTop: 4,
    '.caption': {
        marginTop: 3
    }
});
